<template>
	<div class="pc-card" v-if="data.text.length > 0 || data.video.length > 0">
		<h2 class="pc-card-title">最新影音</h2>
		<!-- <ul class="text-ul">
      <li v-for="item in data.text" :key="item.id" @click="toSquareDetail(item)">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
        <img class="icon" src="./images/icon.png" alt="" />
      </li>
    </ul> -->
		<ul class="video-ul">
			<li v-for="item in data.video.slice(0, 6)" :key="item.id">
				<div class="mark" @click="play(item)"></div>
				<nativeVideo
					class="nativeVideo"
					:url="item.media_url[0]"
					:playerId="'video-' + item.id"
					:key="'video-' + item.id"
					:config="nativeVideoConfig"
				></nativeVideo>
			</li>
		</ul>
		<!-- 弹窗播放 -->
		<n-modal
			v-model:show="showPlayer"
			:trap-focus="true"
			:mask-closable="true"
			:close-on-esc="true"
			:auto-focus="true"
			:block-scroll="true"
			:z-index="1000"
			@after-enter="handleModalOpen"
			@after-leave="handleModalClose"
		>
			<div class="modal-content" tabindex="-1">
				<nativeVideo
					class="play-dialog"
					:url="playData.media_url[0]"
					:playerId="'modal-player-' + playData.id"
					:key="'modal-player-' + playData.id"
					:config="playConfig"
				></nativeVideo>
			</div>
		</n-modal>
	</div>
</template>

<script setup>
import { ref } from "vue";
import nativeVideo from "~/components/nativeVideo/index.vue";

defineProps({
	data: {
		type: Object,
		default: { text: [], video: [] },
	},
});

const nativeVideoConfig = {
	width: "100%",
	height: "100%",
	autoplay: true,
	autoplayMuted: true,
	muted: true,
	loop: true,
	controls: false,
	fluid: true,
	responsive: true,
};

const playConfig = {
	width: "100%",
	height: "100%",
	autoplay: true,
	autoplayMuted: true,
	muted: true,
	loop: true,
	controls: true,
	fluid: true,
	responsive: true,
	fill: true,
};

const showPlayer = ref(false);
const playData = ref({});
const play = item => {
	playData.value = item;
	showPlayer.value = true;
};

// 处理模态框焦点管理
const handleModalOpen = () => {
	// 设置主内容区域为inert（如果浏览器支持）
	const mainContent = document.querySelector("main") || document.querySelector("#__nuxt");
	if (mainContent && "inert" in HTMLElement.prototype) {
		mainContent.inert = true;
	}
};

const handleModalClose = () => {
	// 恢复主内容区域的交互性
	const mainContent = document.querySelector("main") || document.querySelector("#__nuxt");
	if (mainContent && "inert" in HTMLElement.prototype) {
		mainContent.inert = false;
	}
};
</script>

<style lang="scss" scoped>
.pc-card {
	margin-top: 30px;
	padding: 0 63px;
	font-family: PingFang SC;

	.pc-card-title {
		margin: 0 20px 20px;
		font-weight: 600;
		font-size: 32px;
		color: #1f2329;
	}

	.title,
	.desc {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.text-ul {
		display: flex;
		margin-top: 30px;

		li {
			margin-right: 10px;
			display: flex;
			flex-direction: column;
			padding: 32px 32px 18px;
			width: 378px;
			height: 242px;
			background: #ffffff;
			border-radius: 8px;
			cursor: pointer;
			overflow: hidden;

			&:last-child {
				margin-right: 0;
			}

			.title {
				font-weight: 500;
				font-size: 26px;
				color: #333333;
				line-height: 30px;
			}

			.desc {
				margin-top: 12px;
				font-size: 18px;
				color: #646a73;
				line-height: 27px;
			}

			.icon {
				margin-top: auto;
				margin-left: auto;
				width: 32px;
				height: 32px;
			}
		}
	}

	.video-ul {
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;

		li {
			margin-right: 6px;
			margin-bottom: 6px;
			display: flex;
			flex-direction: column;
			position: relative;
			width: 378px;
			height: 242px;
			border-radius: 8px;
			cursor: pointer;
			overflow: hidden;

			.mark {
				width: 100%;
				height: 100%;
				background-color: transparent;
				position: relative;
				z-index: 9;
			}

			.nativeVideo {
				width: 378px;
				height: 242px;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 0;
			}
		}
	}
}

.play-dialog {
	width: 800px;
	height: 450px;
	border-radius: 8px;
	overflow: hidden;
}

.modal-content {
	outline: none;
	border-radius: 8px;
	overflow: hidden;
	position: relative;
	z-index: 1001;
}
</style>
